import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import Swiper from 'react-id-swiper';
import { Styles } from "./styles/heroSlider.js";
import axios from 'axios';

class HeroSlider extends Component {
    constructor(props) {
        super(props);
        this.state = {sliders: []}
    }

    componentDidMount() {
        const fetchAllProducts = async () => {
            await axios.get(`${process.env.REACT_APP_API_URL}/real-fm/api/v1/sliders/find-all`).then((res) => {
                // console.log("Slider" + res.data);
                this.setState({sliders: res.data});
            }).catch(error => {
                console.error(error);
            });
        };
        fetchAllProducts();
    }
    render() {
        const settings = {
            slidesPerView: 1,
            loop: true,
            speed: 3000,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false
            },
            watchSlidesVisibility: true,
            effect: 'fade',
            navigation: {
                nextEl: '.slider-button-next',
                prevEl: '.slider-button-prev'
            },
            renderPrevButton: () => (
                <div className="swiper-btn slider-button-prev"><i className="flaticon-arrow-left-th"></i></div>
            ),
            renderNextButton: () => (
                <div className="swiper-btn slider-button-next"><i className="flaticon-arrow-right-th"></i></div>
            )
        };

        return (
            <Styles>
                {/* Hero Slider */}
                <section className="hero-slider-area">
                    <Swiper {...settings}>
                        {
                            this.state.sliders !== null && this.state.sliders.length > 0 ? this.state.sliders.map((data, i) => (
                                <div className="slider-item" key={i}>
                                    <div className="image-container">
                                        <img src={process.env.REACT_APP_API_BASE_URL.substring(0, process.env.REACT_APP_API_BASE_URL.indexOf("/api")) + `${data.sliderImg.substring(data.sliderImg.indexOf("/uploads"))}`} className="slider-image" alt={data.sliderTitle}  />
                                        {/* <img src={process.env.PUBLIC_URL + `/assets/images/${data.backgroundImage}`} className="slider-image" alt={data.backgroundImage} /> */}
                                    </div>
                                    <div className="slider-table">
                                        <div className="slider-tablecell">
                                            <Container>
                                                <Row>
                                                    <Col md="12">
                                                        <div className="slider-box slider-box1">
                                                            <div className="slider-title">
                                                                <p>{data.sliderTitle}</p>
                                                            </div>
                                                            <div className="slider-desc">
                                                                <h1>{data.sliderDesc}</h1>
                                                            </div>
                                                            <div className="slider-btn">
                                                                <Link className="slider-btn1" to={process.env.PUBLIC_URL + `/contact`}>Contact Us</Link>
                                                                <Link className="slider-btn2" to={process.env.PUBLIC_URL + `/services`}>Our Services</Link>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Container>
                                        </div>
                                    </div>
                                </div>
                            )) : ""
                        }
                    </Swiper>
                </section>
            </Styles>
        )
    }
}

export default HeroSlider
